// extracted by mini-css-extract-plugin
module.exports = {"passwordRequirements":"styles_passwordRequirements__1Ep-r","termsAndConditionsContainer":"styles_termsAndConditionsContainer__33kE6"};